<div class="basic-checkbox" [ngClass]="[type, size, disabled ? 'disabled' : '', model ? 'checked' : 'unchecked']">
  <button
    type="button"
    class="checkbox-button"
    role="checkbox"
    [attr.aria-checked]="type === 'indeterminate' && model ? 'mixed' : model"
    [attr.aria-disabled]="disabled"
    [disabled]="disabled"
    (click)="toggle()"
  >
    <span class="box"></span>
  </button>
  <span class="checkbox-label" *ngIf="label" (click)="toggle()">{{ label }}</span>
</div>


